import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { COMMUNICATION_STATUSES } from "models";
import { CUSTOMER_COMMUNICATIONS } from "modules/AppointmentDetails/components";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Receivers } from "modules/AppointmentDetails/components";

type CustomerCommunicationMutationPayload = {
  communication_type: CUSTOMER_COMMUNICATIONS;
  appointment_id: number;
  customer_id: number | null;
  receivers: Receivers[];
  note?: string;
  question_result_ids?: number[];
};

type CreateCommunicationResponse = {
  receptionist_key: string;
  url: string;
};

const getCommunicationRequest = (communication_type: CUSTOMER_COMMUNICATIONS) => {
  switch (communication_type) {
    case CUSTOMER_COMMUNICATIONS.OnlineCheckin:
      return { endpoint: "/online_checkin/create", baseUrl: ENV.appointmentBaseURL, sentStatus: COMMUNICATION_STATUSES.OnlineCheckInSent };
    case CUSTOMER_COMMUNICATIONS.DiagnoseOverview:
      return { endpoint: "/diagnose_overview/create", baseUrl: ENV.appointmentBaseURLv2, sentStatus: COMMUNICATION_STATUSES.DiagnoseOverviewSent };
    case CUSTOMER_COMMUNICATIONS.RepairOverview:
      return { endpoint: "/repair_overview/create", baseUrl: ENV.appointmentBaseURLv2, sentStatus: COMMUNICATION_STATUSES.RepairOverviewSent };
  }
};

export const useCustomerCommunication = () =>
  useTypedMutation<CustomerCommunicationMutationPayload, CreateCommunicationResponse>({
    mutationFn: async ({ communication_type, ...payload }) => {
      const { endpoint, baseUrl } = getCommunicationRequest(communication_type);
      return (await ApiInstance.post(endpoint, payload, baseUrl)).data;
    },
    onSuccess: ({ communication_type }, { receptionist_key }) => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.customer_communication) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        customer_communication: {
          ...appointment.customer_communication,
          status: getCommunicationRequest(communication_type).sentStatus,
          ...(receptionist_key && { receptionist_key })
        }
      });
    }
  });
